import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import LeagueFixturesByLeagueList from "./LeagueFixturesByLeagueList";
import LeagueFilter from "./LeagueFilter";
import useLichThiDauByLeague from "./useLichThiDauByLeague";
import "@/components/LichThiDauFull/index.css";

/**
 * @param {object} props
 * @param {string} props.league
 */
export default function LichThiDauByLeague({ league: leagueSlug }) {
  const {
    themeStyle,
    activeSlug,
    setActiveSlug,
    league,
    initialMatchesEntries,
    waiting,
    failed,
  } = useLichThiDauByLeague(leagueSlug);

  return (
    <div
      className="kbv-ltd-full flex flex-col gap-2 bg-[var(--theme-bg)] text-[var(--theme-text)]"
      style={themeStyle}
    >
      <div className="kbv-ltd-filter-block">
        <LeagueFilter
          selectedSlug={activeSlug}
          currentLeague={league}
          onSelect={setActiveSlug}
          themeStyle={themeStyle}
        />
      </div>
      {failed ? (
        <NoData message="Không có trận đấu" />
      ) : !activeSlug || waiting ? (
        <LtdLoading />
      ) : (
        <LeagueFixturesByLeagueList
          key={league.id}
          league={league}
          initialMatchesEntries={initialMatchesEntries}
        />
      )}
    </div>
  );
}
